export const SetLocalIdTokenParsed = (idTokenParsed) => localStorage.setItem('idTokenParsed', JSON.stringify(idTokenParsed))

export const GetLocalIdTokenParsed = () => JSON.parse(localStorage.getItem('idTokenParsed'))

export const DeleteLocalIdTokenParsed = () => localStorage.removeItem('idTokenParsed')
